<template>
   <div class="product-leasing">

        <div class="row">
            <div 
                class="small-12 columns" 
                v-bind:class="getColumnsClass()"
                v-for="(service, index) in availableServices" 
                v-bind:key="service._companyKey"
            >
                <div class="static-form bank">
                    <div class="bank__logo">
                        <img 
                            v-bind:src="assetsUrl + service.company().getLogo()" 
                            v-bind:alt="service.company().getName()"
                        >
                    </div>
                    <div 
                        class="form__group form__group--radio" 
                        v-if="radios"
                    >
                        <label
                            v-for="period in companyPeriods[service._companyKey]"
                        >
                            <input 
                                type="radio" 
                                name="leasing" 
                                v-bind:value="service._companyKey + '[' + period + ']'"
                                v-model="selectedCompany"
                                v-on:change="checkCompany"
                            >
                            <div class="form__icon"></div>
                            <div class="form__label">
                                {{ period }} месеца x {{ service.price(price).period(period).perMonth() | format_money }} лв.
                            </div>
                        </label>
                    </div>
                    <div v-else>
                        <div 
                            class="bank__monthly-payment"
                            v-for="period in companyPeriods[service._companyKey]"
                        >
                            {{ period }} месеца x {{ service.price(price).period(period).perMonth() | format_money }} лв.
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="radios && error && (!company || !period)" class="small-12 columns">
                <div class="form__error">
                    {{ error }}
                </div>
            </div>
            <div v-if="radios && company && period" class="bank__description small-12 columns">
                <input type="hidden" name="leasing_period" v-bind:value="period">
                <input type="hidden" name="leasing_company" v-bind:value="company">
                <input type="hidden" name="leasing_monthly" v-bind:value="availableServices[company].price(price).period(period).perMonth()">
                <input type="hidden" name="leasing_total" v-bind:value="availableServices[company].price(price).period(period).total()">

                <div v-html="availableServices[company]._company.summary(period, price)"></div>

                <div class="static-form cart__group cart__actions" 
                     v-if="company == 'bnp' || company == 'dsk'">
                    <div class="form__group form__group--checkbox">
					    <label>
					        <input type="checkbox" value="1" @change="checkedBnpCreditConditions" :checked="checkCreditCondition">
					        <div class="form__icon"></div>
					        <div class="form__label">
					           Съгласен съм с условията за кандидатстване за кредит
					        </div>
					    </label>
					</div>
                    <div class="form__group form__group--checkbox">
					    <label>
					        <input type="checkbox" value="2" @change="checkedPersonalDataInfo" :checked="checkPersonalDataInfo">
					        <div class="form__icon"></div>
					        <div class="form__label">
					           Прочетох информацията за защита на личните данни
					        </div>
					    </label>
					</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>

    export default {

        props: {

            radios: {
                type: Boolean,
                required: false,
                default: () => { return false }
            },

            assetsUrl: {
                type: String,
                required: false,
                default: () => { return "/" }
            },

            price: {
                type: Number,
                required: true
            },

            error: {
                type: String,
                required: false
            },

            selected: {
                type: String,
                required: false
            },

        },


        data() {
            return {
                selectedCompany: this.selected,
                companyPeriods: {},
                checkCreditCondition: false,
                checkPersonalDataInfo: false
            };
        },

        computed: {
            availableServices: () => Leasing.getAll(),
            // availablePeriods: () => Leasing.getAvailablePeriods(),
            company() {
                if (this.selectedCompany) {
                    return this.selectedCompany.split("[")[0];
                }

                return null;
            },
            period() {
                if (this.selectedCompany) {
                    return parseInt(this.selectedCompany.split("[")[1].split("]")[0], 10);
                }

                return null;
            },
            
        },

        watch: {
            price: function (newValue) {
                for (var service in this.availableServices) {
                    this.setCompanyPeriods(service);
                }
            },
        },

        methods: {

            getColumnsClass() {
                return [ 'medium-' + new String(Math.floor(12 / Object.keys(this.availableServices).length)) ];
            },

            setCompanyPeriods(service) {
                var companyPeriods = Leasing.get(service).company().availablePeriods(this.price);
                this.companyPeriods[service] = Object.keys(companyPeriods);
                return;
            },

            checkCompany() {
                this.checkCreditCondition = false;
                this.checkPersonalDataInfo = false;
                
                this.$eventBus.$emit("check-selected-company", this.company, this.checkCreditCondition, this.checkPersonalDataInfo);
            },

            checkedBnpCreditConditions() {
                this.checkCreditCondition = !this.checkCreditCondition;
                this.$eventBus.$emit("checked-credit-conditions", this.checkCreditCondition);
            },

            checkedPersonalDataInfo() {
                this.checkPersonalDataInfo = !this.checkPersonalDataInfo;
                this.$eventBus.$emit("checked-peronal-data", this.checkPersonalDataInfo);
            }
        },
      
        beforeMount() {
            for (var service in this.availableServices) {
                this.setCompanyPeriods(service);
            }
        },

    }
</script>
